/**
 * Employee Web — `/me/travel` landing index route.
 *
 * Renders the travel landing under the pathless `_auth.me.travel` parent (which
 * now renders an <Outlet/>). Permission gate: `travel:read:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeTravelLanding } from "../features/travel/MeTravelLanding";

export const Route = createFileRoute("/_auth/me/travel/")({
  beforeLoad: requirePermission({
    anyOf: ["travel:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeTravelIndexRoute,
});

function MeTravelIndexRoute(): JSX.Element {
  return <MeTravelLanding />;
}
